// CRUD de eventos de engagement y helpers básicos

import { supabase } from '../../../supabaseClient';

/**
 * Crear evento de engagement
 */
export const createEngagementEvent = async (
  propertyId,
  inviteToken,
  sessionId,
  eventType,
  eventData = {},
  metadata = {}
) => {
  try {
    const { data, error } = await supabase
      .from('engagement_events')
      .insert([
        {
          property_id: propertyId,
          invite_token: inviteToken,
          session_id: sessionId,
          event_type: eventType,
          event_data: eventData,
          metadata: metadata,
        },
      ])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error creando evento de engagement:', error);
    throw error;
  }
};

/**
 * Obtener eventos de una propiedad
 */
export const getPropertyEngagementEvents = async (propertyId) => {
  try {
    const { data, error } = await supabase
      .from('engagement_events')
      .select('*')
      .eq('property_id', propertyId)
      .order('created_at', { ascending: false })
      .limit(10000);

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error obteniendo eventos de propiedad:', error);
    throw error;
  }
};

/**
 * Obtener eventos de un invitado específico
 */
export const getInviteEngagementEvents = async (propertyId, inviteToken) => {
  try {
    const { data, error } = await supabase
      .from('engagement_events')
      .select('*')
      .eq('property_id', propertyId)
      .eq('invite_token', inviteToken)
      .order('created_at', { ascending: false })
      .limit(5000);

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error obteniendo eventos de invitado:', error);
    throw error;
  }
};

/**
 * Obtener metadatos del navegador
 */
export const getBrowserMetadata = () => {
  return {
    userAgent: navigator.userAgent,
    language: navigator.language,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};

/**
 * Generar ID de sesión único
 */
export const generateSessionId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};